import { Step } from "react-joyride";

const jobCostModalTourSteps: Step[] = [
  {
    target: ".tour-job-costing-summary",
    content:
      "Shows your costing progress and whether actual costs are higher or lower than proposed costs. The Threshold Variance is set within your Organization Settings.",
  },
  {
    target: ".tour-job-cost-date",
    content:
      "Select the Day you want to Cost.  If the Job spans multiple days, inputs can be entered and saved for each.",
  },
  {
    target: ".tour-add-material",
    content:
      "Begin inputting the ACTUAL quantities of material used. You may add multiple materials by clicking “Add Material.”",
    placement: "bottom",
    skipScroll: true,
  },
  {
    target: ".tour-add-employees",
    content:
      "Select Employee/s or crew/s present at the Job, enter their Time on Job, and Travel Times.",
  },/*
  {
    target: ".tour-add-equipment-window",
    content:
      "Input the actual Travel Time and Job Time for your Equipment. Add multiple Equipment items by clicking “Add Equipment Cost”.",
  },*/
  {
    target: ".tour-add-equipment-cost",
    content: "Input the actual Travel Time and Job Time for your Equipment. Add multiple Equipment items by clicking “Add Equipment Cost”.",
  },
  {
    target: ".tour-add-additional-cost",
    content: "Include any other Costs associated with this Job.",
  },
  {
    target: ".tour-add-transfer-truck",
    content: "Input the number of hours Trucks hauled Material to calculate Trucking Costs.",
  },
  {
    target: ".tour-save-day",
    content:
      "Clicking here will save the costs created for the Date selected at the top of the Modal. Each day of the job can be saved as a separate entry.",
  },
];

export default jobCostModalTourSteps;
